define(function() {
	const builder = require('civicsUtils/buildUrlParameters');
	const IPSModelCollection = require('civicsBase/ipsModelCollection');
	const CN = require('civicsUtils/constants');
	const utilities = require('civicsViews/card_view_list/utilities/card_view_utilities');
	const instrument_utility = require('civicsUtils/instrument_utilities');

	return IPSModelCollection.extend({
		urlRoot: '/delegate/civics-api/api/core/views/instruments',
		url: function() {

			var parameters = '';
			if (this.urlParameters != undefined) {
				parameters = builder.buildUrlParameters(this.urlParameters);
			}
			if (this.relationType == 'included') {
				if (parameters.indexOf('?') >= 0) {
					parameters += '&showall=true';
				} else {
					parameters += '?showall=true';
				}
			}
			if (this.useRelationshipView) {
				if (parameters.indexOf('?') >= 0) {
					parameters += '&relationshipview=' + this.useRelationshipView;
				} else {
					parameters += '?relationshipview=' + this.useRelationshipView;
				}
			}

			var ret = ''

			if (this.storedProcedureMode === true){

				if (this.relationType == 'included') {
					ret = '/delegate/civics-api/api/portal/projects/' + this.instrumentId + '/includedinstruments';
				} else {
					ret = '/delegate/civics-api/api/portal/applications/' +this.instrumentType+'/'+this.instrumentId+'/relatedinstruments' + parameters;
				}
				//fallback
				//ret = this.urlRoot +'/'+this.instrumentType+'/'+this.instrumentId+'/'+this.relationType + parameters;
			} else {
				//temporary code while we switch RS parameter names. this way we won't break QA builds.
				ret = this.urlRoot +'/'+this.instrumentType+'/'+this.instrumentId+'/'+this.relationType + parameters;
			}

			return ret;
		},
		modelId:function(attrs){
			return attrs.instrumentType+'_'+attrs.id;
		},
		setupFetch:function(model, cardConfigAttribute, cardConfig, useRelationshipView){
			let relatedTypesFilter = utilities.getRelatedRecordTypesFilter(instrument_utility.getCDRType(model.get('instrumentType').toLowerCase()), cardConfigAttribute, cardConfig);
			this.relationType = 'related';
			this.storedProcedureMode = true;
			this.instrumentType = model.get('instrumentType');
			this.instrumentId = model.get('id');
			this.useRelationshipView = useRelationshipView;

			var urlParameters = {
				extendedFilter: {
					Or: relatedTypesFilter
				}
			};

			this.urlParameters = urlParameters;
		},
		parse: function(response) {
			var data = response.data;
			for (i = 0; i < data.length; i++) {
				data[i].id = data[i].instrumentId;
				data[i].unique_id = data[i].instrumentType + '-' + data[i].instrumentId;
				switch (data[i].instrumentType.toLowerCase()) {
					case 'buildingapplication':
						data[i]._cdrType = 'building';
						break;
					case 'businesslicense':
						data[i]._cdrType = 'businesslicense';
						break;
					case 'case':
						data[i]._cdrType = 'codeenforcement';
						break;
					case 'planningapplication':
						data[i]._cdrType = 'planning';
						break;
					case 'projectapplication':
						data[i]._cdrType = 'project';
						break;
					case 'tradelicense':
						data[i]._cdrType = 'tradelicense';
						break;
					case 'useapplication':
						data[i]._cdrType = 'use';
						break;
					case 'servicerequest':
						data[i]._cdrType = 'servicerequest';
						break;
					default:
						console.log('undefined/invalid product family from the instrument response');
				}
			}
			return data;
		},
	});
});
